import { createApp } from "vue";
import VueGtag from "vue-gtag-next";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import { i18n } from "./utils/i18n";
import sysconfig from "./constants/sysconfig";
import toastPlugin from "@/plugins/toastPlugin";
import "sweetalert2/dist/sweetalert2.min.css";

const app = createApp(App);
app
  .use(store)
  .use(router)
  .use(VueGtag, { property: { id: sysconfig.googleAnalytics.trackingId } })
  .use(i18n)
  .use(toastPlugin)
  .mount("#app");

export { app };
